import React from 'react';
import { Alert, Box } from '@mui/material';
import { isDmsAdmin, canAccessManualEditors } from '../utils/dmsPermissions';

export default function AdminRoute({ user, children, editorOnly = false }) {
  const allowed = editorOnly ? canAccessManualEditors(user) : isDmsAdmin(user);
  if (!allowed) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="warning">
          {editorOnly
            ? 'You need admin or superadmin access to view this page.'
            : 'You need DMS admin access to view this page.'}
        </Alert>
      </Box>
    );
  }
  return children;
}